<div class="filter-panel">
    <div class="filter-panel_item filter-panel_tabs">
        @for (tab of TABS; track tab.value; let i = $index) {
            <div
                 class="filter-panel_tabs-item"
                 [class.-first]="i === 0"
                 [class.-active]="tab.value === $currentTab()"
                 (click)="onSelectTab(tab.value, $event)">
                <span class="filter-panel_tabs-item_name">{{tab.label | l10n}}</span>
            </div>
        }
    </div>

    @if ($currentTab() === DexTxHistoryWidgetTab.HISTORY) {
        <text-search-input
            class="filter-panel_item"
            [searchFilter]="$any(widgetFilter.filters.hash)"
            (filterChange)="widgetFilter.onChange()">
        </text-search-input>

        <multiselect-search-input
            class="filter-panel_item"
            [searchFilter]="$any(widgetFilter.filters.method)"
            (filterChange)="widgetFilter.onChange()">
        </multiselect-search-input>

        <text-search-input
            class="filter-panel_item"
            [searchFilter]="$any(widgetFilter.filters.address)"
            (filterChange)="widgetFilter.onChange()">
        </text-search-input>

        <multiselect-search-input
            class="filter-panel_item"
            [searchFilter]="$any(widgetFilter.filters.status)"
            (filterChange)="widgetFilter.onChange()">
        </multiselect-search-input>

        <button refreshButton
                class="filter-panel_item"
                (click)="refresh$.next()">
        </button>
    }
</div>

<partial-loading-indicator class="dex-tx-history-w_loading-indicator -table-with-pagination" #loadingFullEl>

    <partial-loading-indicator
        class="dex-tx-history-w_loading-indicator -table-only"
        [class.-with-pagination]="$currentTab() === DexTxHistoryWidgetTab.HISTORY"
        #loadingPageEl>

        <div class="dex-tx-history-w_complex-table" [table]="table" #tableEl>
            <div class="dex-tx-history-w_table-header-wrapper">
                <table class="dex-tx-history-w_table">
                    <thead>
                    <tr tableHeaderRow>
                        <th textHiding *tableColumn="table.columnsDict.HASH; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.ORDER_ID; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.METHOD; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.SENT; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.RECEIVED; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.PRICE; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.FEE; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.GAS; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.ACCOUNT; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.CREATED_AT; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.UPDATED_AT; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                        <th textHiding *tableColumn="table.columnsDict.STATUS; let column" class="dex-tx-history-w_table_header">
                            <span>{{column.label | l10n}}</span>
                        </th>
                    </tr>
                    </thead>
                </table>
            </div>
            <div class="dex-tx-history-w_table-body-wrapper" customScrollbar [elementRuler]="resize$">
                <table class="dex-tx-history-w_table">
                    <tbody>
                    <tr *tableBodyRow="let _row of table.rows; let isEmpty=empty"
                        class="dex-tx-history-w_table_row" [class.-empty]="isEmpty"
                        (click)="onRowClick(_row, $event)">

                        @let row = getTypedRow(_row);

                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell">
                            <span [copyTxExploreTooltip]="row.hash">{{row.hash | shortenWalletAddr}}</span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            [tooltip]="row.orderId">
                            <span>{{row.orderId}}</span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            [tooltip]="row.method">
                            <span>{{row.method  | l10n}}</span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            tooltip #amountTooltip='tooltip'>
                            @let v = $safeNavigationMigration(row.$amount?.());
                            @if (v) {
                                <span [displayDecimal]="v | valueWithDelDisplayDecimal" [tooltipDirective]="amountTooltip"></span>
                            } @else {
                                <span></span>
                            }
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            tooltip #receivedTooltip='tooltip'>
                        <span>
                            @let vs = $safeNavigationMigration(row.$received?.());
                            @for (v of vs; track v.d.deliverableId; let index = $index) {
                                <span [displayDecimal]="v | valueWithDelDisplayDecimal" [tooltipDirective]="receivedTooltip"></span>
                                @if (index < vs.length - 1) {
                                    {{' '}}
                                }
                            }
                        </span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            tooltip #priceTooltip='tooltip'>
                            @let v = $safeNavigationMigration(row.$price?.());
                            <span [displayDecimal]="v | valueWithDelDisplayDecimal" [tooltipDirective]="priceTooltip"></span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            tooltip #feeTooltip='tooltip'>
                            @let v = $safeNavigationMigration(row.$fee?.());
                            <span [displayDecimal]="v | valueWithDelDisplayDecimal" [tooltipDirective]="feeTooltip"></span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            tooltip #gasTooltip='tooltip'>
                            @let v = row.gasUsedNative;
                            <span [displayDecimal]="v | valueWithDelDisplayDecimal" [tooltipDirective]="gasTooltip"></span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell">
                            <span class="dex-tx-history-w_table_cell_account">
                                @if (row.address) {
                                    <span class="dex-tx-history-w_table_cell_account-row-wrapper">
                                        <span>
                                            <wallet-avatar
                                                class="dex-tx-history-w_table_cell_account-avatar"
                                                [address]="row.address"
                                                [isChangeOnClickEnabled]="true">
                                            </wallet-avatar>
                                            <span [copyTooltip]="row.address">{{ row.address | shortenWalletAddr }}</span>
                                        </span>

                                        @if (row.showBothAddresses && row.addressTo) {
                                            <svg class="dex-tx-history-w_table_cell_account-separator"><use xlink:href="#convertation-arrow"></use></svg>
                                            <span>
                                                <wallet-avatar
                                                    class="dex-tx-history-w_table_cell_account-avatar"
                                                    [address]="row.addressTo"
                                                    [isChangeOnClickEnabled]="true">
                                                </wallet-avatar>
                                                <span [copyTooltip]="row.addressTo">{{ row.addressTo | shortenWalletAddr }}</span>
                                            </span>
                                        }
                                    </span>
                                }
                            </span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            [tooltip]="row.createdAt">
                            <span>{{row.createdAt}}</span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell"
                            [tooltip]="row.updatedAt">
                            <span>{{row.updatedAt}}</span>
                        </td>
                        <td textHiding *tableColumn class="dex-tx-history-w_table_cell -status {{row.statusClass}}"
                            [tooltip]="row.status | l10n">
                            <span>{{row.status  | l10n}}</span>

                            @let rejectReason = $safeNavigationMigration(row.raw?.order?.rejectReason);
                            @if (rejectReason) {
                                <span class="-i" [tooltipL10n]="'components.dex-order-cancel-reason.' + rejectReason" [tooltipL10nFallback]="rejectReason"> ⓘ</span>
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </partial-loading-indicator>

    @if ($currentTab() === DexTxHistoryWidgetTab.HISTORY) {
        <table-pagination
            #tablePaginationEl
            [filter]         = "listFilter"
            [paginationInfo] = "listInfo"
            (filterChange)   = "paginationChanged$.next()">
        </table-pagination>
    }

</partial-loading-indicator>

<ng-template #innerModalAnchorEl></ng-template>
